import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-41bf0248"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content-box"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = {
  class: "top_left"
};
const _hoisted_4 = {
  class: "shipments"
};
const _hoisted_5 = {
  class: "selectBox"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "店铺类型 ", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "物流状态 ", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "物流分类 ", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "供应商名称 ", -1));
const _hoisted_10 = {
  class: "areaBox"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "店铺城市 ", -1));
const _hoisted_12 = {
  class: "btnBox"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "物流表上传", -1));
const _hoisted_14 = {
  class: "upload-box"
};
const _hoisted_15 = {
  class: "upload-box-title"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "upload-box-title-text"
}, "物流表上传", -1));
const _hoisted_17 = {
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "white"
  }
}, "浏览", -1));
const _hoisted_19 = {
  class: "upload-box-dashed"
};
const _hoisted_20 = {
  class: "upload-icon-group-box"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__text"
}, [/*#__PURE__*/_createElementVNode("div", null, "点击或者拖动文件到虚线框内上传"), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "12px"
  }
}, " 支持xls，xlsx类型的文件 ")], -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "导出", -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "1px",
    "height": "20px",
    "background-color": "#c0c4cc",
    "margin-right": "8px"
  }
}, null, -1));
const _hoisted_24 = {
  class: "progress top_right"
};
const _hoisted_25 = {
  class: "percentage-value"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "percentage-label"
}, "总进度", -1));
const _hoisted_28 = {
  class: "insTableBox"
};
const _hoisted_29 = {
  class: "TipsBox"
};
const _hoisted_30 = {
  class: "tipsPopover"
};
const _hoisted_31 = {
  class: "_title"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "店铺信息", -1));
const _hoisted_33 = {
  class: "info"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "地址：", -1));
const _hoisted_35 = {
  class: "info"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "联系人：", -1));
const _hoisted_37 = {
  class: "info"
};
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "电话：", -1));
const _hoisted_39 = {
  class: "TipsBox"
};
const _hoisted_40 = {
  class: "tipsPopover"
};
const _hoisted_41 = {
  class: "_title"
};
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "供应商信息", -1));
const _hoisted_43 = {
  class: "info"
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "联系人：", -1));
const _hoisted_45 = {
  class: "info"
};
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "电话：", -1));
const _hoisted_47 = {
  class: "TipsBox"
};
const _hoisted_48 = {
  class: "tipsPopover"
};
const _hoisted_49 = {
  class: "_title"
};
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "收货信息", -1));
const _hoisted_51 = {
  class: "info"
};
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "联系人：", -1));
const _hoisted_53 = {
  class: "info"
};
const _hoisted_54 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "电话：", -1));
const _hoisted_55 = {
  key: 0,
  class: "info"
};
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "车牌：", -1));
const _hoisted_57 = {
  key: 0
};
const _hoisted_58 = {
  class: "TipsBox"
};
const _hoisted_59 = {
  class: "tipsPopover1"
};
const _hoisted_60 = {
  style: {
    "border-bottom": "1px solid #000",
    "padding-bottom": "5px",
    "font-size": "18px"
  }
};
const _hoisted_61 = {
  key: 1
};
const _hoisted_62 = {
  class: "TipsBox"
};
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString("在途中"), -1));
const _hoisted_64 = {
  class: "tipsPopover3"
};
const _hoisted_65 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "已送达", -1));
const _hoisted_66 = {
  key: 1
};
const _hoisted_67 = {
  class: "paginationBox"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_input = _resolveComponent("el-input");
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_el_progress = _resolveComponent("el-progress");
  const _component_el_link = _resolveComponent("el-link");
  const _component_vxe_column = _resolveComponent("vxe-column");
  const _component_vxe_table = _resolveComponent("vxe-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, [_hoisted_6, _createVNode(_component_el_select, {
    modelValue: $setup.converQuery.insSelect.storeType,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.converQuery.insSelect.storeType = $event),
    clearable: "",
    placeholder: "请选择",
    size: "small"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storeTypeData, item => {
      return _openBlock(), _createBlock(_component_el_option, {
        label: item.storeTypeNameZh,
        value: item.storeTypeId,
        key: item.storeTypeId
      }, null, 8, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("div", null, [_hoisted_7, _createVNode(_component_el_select, {
    modelValue: $setup.converQuery.insSelect.state,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.converQuery.insSelect.state = $event),
    clearable: "",
    placeholder: "请选择",
    size: "small"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.expressStateListData, item => {
      return _openBlock(), _createBlock(_component_el_option, {
        label: item.expressStateName,
        value: item.expressStateId,
        key: item.expressStateId
      }, null, 8, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("div", null, [_hoisted_8, _createVNode(_component_el_select, {
    modelValue: $setup.converQuery.insSelect.logisticsTypeId,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.converQuery.insSelect.logisticsTypeId = $event),
    clearable: "",
    placeholder: "请选择",
    size: "small"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.logisticsTypeData, item => {
      return _openBlock(), _createBlock(_component_el_option, {
        label: item.logisticsTypeNameZh,
        value: item.logisticsTypeId,
        key: item.logisticsTypeId
      }, null, 8, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("div", null, [_hoisted_9, _createVNode(_component_el_select, {
    disabled: $setup.vendorId.length > 0,
    modelValue: $setup.converQuery.insSelect.vendorId,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.converQuery.insSelect.vendorId = $event),
    clearable: "",
    placeholder: "请选择",
    size: "small"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.vendorData, item => {
      return _openBlock(), _createBlock(_component_el_option, {
        label: item.vendorName,
        value: item.vendorId,
        key: item.vendorId
      }, null, 8, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["disabled", "modelValue"])]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createVNode(_component_el_input, {
    modelValue: $setup.converQuery.insSelect.areaInput,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $setup.converQuery.insSelect.areaInput = $event),
    placeholder: "请输入内容",
    style: {
      "width": "60%"
    }
  }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", null, [_createVNode(_component_el_popover, {
    visible: $setup.uploadConverPopoverVisible,
    placement: "bottom",
    trigger: "click",
    width: "auto",
    teleported: false,
    "popper-class": "upload-box-popper"
  }, {
    reference: _withCtx(() => [$setup.permission.havePermission('安装及发货进度', '物流表上传') ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      class: "button-default",
      color: "black",
      onClick: $setup.openUploadConverPopover,
      style: {
        "margin-right": "15px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_svg_icon, {
        iconName: "upload",
        iconColor: 'white',
        iconSize: "15px"
      }), _hoisted_13]),
      _: 1
    }, 8, ["onClick"])) : _createCommentVNode("", true)]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_hoisted_16, _createVNode(_component_svg_icon, {
      iconName: "close",
      iconColor: 'black',
      iconSize: "15px",
      style: {
        "cursor": "pointer",
        "padding": "3px"
      },
      onClick: _cache[5] || (_cache[5] = $event => $setup.uploadConverPopoverVisible = false)
    })]), _createVNode(_component_el_upload, {
      "on-exceed": $setup.handleConverExceed,
      class: "upload-pane",
      drag: "",
      ref: "uploadConverPane",
      action: $setup.uploadConverData.signatureData.host,
      "before-upload": $setup.handleConverBeforeUpload,
      "on-success": $setup.handleConverOnSuccess,
      data: $setup.uploadConverData.data,
      limit: 1,
      "file-list": $setup.uploadConverData.fileList
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createVNode(_component_el_button, {
        class: "button-default",
        color: "#539ce0",
        style: {
          "width": "100px",
          "margin": "5px 0px"
        }
      }, {
        default: _withCtx(() => [_hoisted_18]),
        _: 1
      }), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createVNode(_component_svg_icon, {
        iconName: "Excel",
        iconSize: "18px"
      }), _createVNode(_component_svg_icon, {
        iconName: "upload",
        iconSize: "18px"
      })]), _hoisted_21])])]),
      _: 1
    }, 8, ["on-exceed", "action", "before-upload", "on-success", "data", "file-list"])])]),
    _: 1
  }, 8, ["visible"]), $setup.permission.havePermission('安装及发货进度', '物流表导出') ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    class: "button-default",
    color: "black",
    style: {
      "margin-right": "15px"
    },
    onClick: $setup.openExportEvent
  }, {
    default: _withCtx(() => [_createVNode(_component_svg_icon, {
      iconName: "Download",
      iconColor: 'white',
      iconSize: "15px"
    }), _hoisted_22]),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createVNode(_component_el_input, {
    class: "light-gray-input",
    modelValue: $setup.converQuery.insValue,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $setup.converQuery.insValue = $event),
    placeholder: "搜索",
    style: {
      "width": "154px"
    }
  }, {
    suffix: _withCtx(() => [_hoisted_23, _createVNode(_component_el_button, {
      style: {
        "padding": "0px",
        "margin": "0px",
        "border": "none",
        "max-width": "20px",
        "max-height": "20px"
      },
      circle: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_svg_icon, {
        onClick: _cache[6] || (_cache[6] = $event => $setup.searchClick()),
        iconName: "search",
        iconSize: "18px",
        iconBackgroundColor: "#f3f3f3"
      })]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_24, [_createVNode(_component_el_progress, {
    type: "circle",
    percentage: 75
  }, {
    default: _withCtx(({
      percentage
    }) => [_createElementVNode("span", _hoisted_25, _toDisplayString(percentage) + "%", 1), _hoisted_26, _hoisted_27]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_28, [_createVNode(_component_vxe_table, {
    size: "small",
    class: "column-sort",
    ref: "converTable",
    "export-config": {},
    height: "auto",
    data: $setup.converData,
    "row-config": {
      useKey: true
    },
    loading: $setup.converLoading,
    "column-config": {
      useKey: true
    },
    "sort-config": {
      showIcon: false
    },
    onHeaderCellClick: $setup.headerCellConverClickEvent,
    onScroll: $setup.converTableScroll
  }, {
    default: _withCtx(() => [_createVNode(_component_vxe_column, {
      field: "storeName",
      title: "店铺名称",
      "min-width": "300",
      sortable: ""
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), _createVNode(_component_svg_icon, {
        class: _normalizeClass(["table-sort", {
          'is-order': column.order
        }]),
        iconName: "sort",
        iconSize: "18px"
      }, null, 8, ["class"])]),
      default: _withCtx(({
        row
      }) => [_createElementVNode("div", null, [_createVNode(_component_el_popover, {
        modelValue: row.popoverVisible,
        "onUpdate:modelValue": $event => row.popoverVisible = $event,
        placement: "top",
        trigger: "click",
        "popper-style": "min-width: 0px;width: auto;background:#f3f3f3",
        teleported: false,
        "show-arrow": false
      }, {
        reference: _withCtx(() => [_createElementVNode("div", _hoisted_29, [_createElementVNode("span", null, _toDisplayString(row.storeName), 1), _createVNode(_component_el_link, {
          underline: false
        }, {
          default: _withCtx(() => [_createVNode(_component_svg_icon, {
            class: "tip",
            iconName: "Tips",
            iconSize: "15px"
          })]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_hoisted_32, _createVNode(_component_svg_icon, {
          iconName: "copy",
          iconSize: "18px",
          onClick: $event => $setup.copyStore(row)
        }, null, 8, ["onClick"])]), _createElementVNode("div", _hoisted_33, [_hoisted_34, _createElementVNode("p", null, _toDisplayString(row.storeAddress), 1)]), _createElementVNode("div", _hoisted_35, [_hoisted_36, _createElementVNode("p", null, _toDisplayString(row.storeContactName), 1)]), _createElementVNode("div", _hoisted_37, [_hoisted_38, _createElementVNode("p", null, _toDisplayString(row.storeContactMobile), 1)])])]),
        _: 2
      }, 1032, ["modelValue", "onUpdate:modelValue"])])]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "storeTypeId",
      title: "店铺类型",
      "min-width": "100",
      sortable: "",
      "show-overflow": ""
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), _createVNode(_component_svg_icon, {
        class: _normalizeClass(["table-sort", {
          'is-order': column.order
        }]),
        iconName: "sort",
        iconSize: "18px"
      }, null, 8, ["class"])]),
      default: _withCtx(({
        row
      }) => [_createTextVNode(_toDisplayString($setup.getName("storeTypeId", row.storeTypeId)), 1)]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "vendorName",
      title: "供应商",
      "min-width": "100",
      sortable: ""
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), _createVNode(_component_svg_icon, {
        class: _normalizeClass(["table-sort", {
          'is-order': column.order
        }]),
        iconName: "sort",
        iconSize: "18px"
      }, null, 8, ["class"])]),
      default: _withCtx(({
        row
      }) => [_createElementVNode("div", null, [_createVNode(_component_el_popover, {
        modelValue: row.popoverVisible,
        "onUpdate:modelValue": $event => row.popoverVisible = $event,
        placement: "bottom",
        trigger: "click",
        "popper-style": "min-width: 0px;width: auto;background:#f3f3f3",
        teleported: false,
        "show-arrow": false
      }, {
        reference: _withCtx(() => [_createElementVNode("div", _hoisted_39, [_createElementVNode("span", null, _toDisplayString(row.vendorName), 1), _createVNode(_component_el_link, {
          underline: false
        }, {
          default: _withCtx(() => [_createVNode(_component_svg_icon, {
            class: "tip",
            iconName: "Tips",
            iconSize: "15px"
          })]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_hoisted_42, _createVNode(_component_svg_icon, {
          iconName: "copy",
          iconSize: "18px",
          onClick: $event => $setup.copyVendor(row)
        }, null, 8, ["onClick"])]), _createElementVNode("div", _hoisted_43, [_hoisted_44, _createElementVNode("p", null, _toDisplayString(row.contactName), 1)]), _createElementVNode("div", _hoisted_45, [_hoisted_46, _createElementVNode("p", null, _toDisplayString(row.contactMobile), 1)])])]),
        _: 2
      }, 1032, ["modelValue", "onUpdate:modelValue"])])]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "vendorTypeId",
      title: "服务内容",
      "min-width": "100",
      sortable: ""
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), _createVNode(_component_svg_icon, {
        class: _normalizeClass(["table-sort", {
          'is-order': column.order
        }]),
        iconName: "sort",
        iconSize: "18px"
      }, null, 8, ["class"])]),
      default: _withCtx(({
        row
      }) => [_createTextVNode(_toDisplayString(row.vendorTypeNameZh), 1)]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "city",
      title: "城市",
      "min-width": "100",
      sortable: ""
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), _createVNode(_component_svg_icon, {
        class: _normalizeClass(["table-sort", {
          'is-order': column.order
        }]),
        iconName: "sort",
        iconSize: "18px"
      }, null, 8, ["class"])]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "logisticsTypeNameZh",
      title: "物流分类",
      "min-width": "100",
      sortable: ""
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), _createVNode(_component_svg_icon, {
        class: _normalizeClass(["table-sort", {
          'is-order': column.order
        }]),
        iconName: "sort",
        iconSize: "18px"
      }, null, 8, ["class"])]),
      default: _withCtx(({
        row
      }) => [_createElementVNode("span", null, _toDisplayString(row.logisticsTypeNameZh), 1)]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "logisticsOrderCode",
      title: "物流信息",
      "min-width": "100",
      sortable: ""
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), _createVNode(_component_svg_icon, {
        class: _normalizeClass(["table-sort", {
          'is-order': column.order
        }]),
        iconName: "sort",
        iconSize: "18px"
      }, null, 8, ["class"])]),
      default: _withCtx(({
        row
      }) => [_createElementVNode("div", null, [_createVNode(_component_el_popover, {
        modelValue: row.popoverVisible,
        "onUpdate:modelValue": $event => row.popoverVisible = $event,
        placement: "bottom",
        trigger: "click",
        "popper-style": "min-width: 0px;width: auto;background:#f3f3f3",
        teleported: false,
        "show-arrow": false
      }, {
        reference: _withCtx(() => [_createElementVNode("div", _hoisted_47, [_createElementVNode("span", null, _toDisplayString(row.logisticsOrderCode), 1), _createVNode(_component_el_link, {
          underline: false
        }, {
          default: _withCtx(() => [_createVNode(_component_svg_icon, {
            class: "tip",
            iconName: "Tips",
            iconSize: "15px"
          })]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_hoisted_50, _createVNode(_component_svg_icon, {
          iconName: "copy",
          iconSize: "18px",
          onClick: $event => $setup.copyVendor(row)
        }, null, 8, ["onClick"])]), _createElementVNode("div", _hoisted_51, [_hoisted_52, _createElementVNode("p", null, _toDisplayString(row.contacts), 1)]), _createElementVNode("div", _hoisted_53, [_hoisted_54, _createElementVNode("p", null, _toDisplayString(row.phoneNumber), 1)]), row.logisticsTypeNameZh !== '物流' ? (_openBlock(), _createElementBlock("div", _hoisted_55, [_hoisted_56, _createElementVNode("p", null, _toDisplayString(row.logisticsOrderCode), 1)])) : _createCommentVNode("", true)])]),
        _: 2
      }, 1032, ["modelValue", "onUpdate:modelValue"])])]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "expressStateName",
      title: "物流状态",
      "min-width": "100",
      sortable: ""
    }, {
      header: _withCtx(({
        column
      }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), _createVNode(_component_svg_icon, {
        class: _normalizeClass(["table-sort", {
          'is-order': column.order
        }]),
        iconName: "sort",
        iconSize: "18px"
      }, null, 8, ["class"])]),
      default: _withCtx(({
        row
      }) => [row.logisticsTypeNameZh === '物流' ? (_openBlock(), _createElementBlock("div", _hoisted_57, [_createVNode(_component_el_popover, {
        modelValue: row.popoverVisible,
        "onUpdate:modelValue": $event => row.popoverVisible = $event,
        placement: "left",
        trigger: "click",
        "popper-style": "min-width: 0px;width: auto;background:#f3f3f3",
        teleported: false,
        "show-arrow": false
      }, {
        reference: _withCtx(() => [_createElementVNode("div", _hoisted_58, [_createElementVNode("span", null, _toDisplayString(row.expressStateName), 1), _createVNode(_component_el_link, {
          underline: false
        }, {
          default: _withCtx(() => [_createVNode(_component_svg_icon, {
            class: "tip",
            iconName: "unfold",
            iconSize: "15px"
          })]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_59, [_createElementVNode("p", _hoisted_60, _toDisplayString(row.expressStateName), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.expressTraces.slice().reverse(), (x, index) => {
          return _openBlock(), _createElementBlock("p", {
            key: index
          }, [_createElementVNode("span", null, _toDisplayString(x.expressTraceAcceptTime), 1), _createTextVNode(" 　 "), _createElementVNode("span", null, _toDisplayString(x.expressTraceAcceptStation), 1)]);
        }), 128))])]),
        _: 2
      }, 1032, ["modelValue", "onUpdate:modelValue"])])) : (_openBlock(), _createElementBlock("div", _hoisted_61, [row.expressStateName !== '已签收' ? (_openBlock(), _createBlock(_component_el_popover, {
        key: 0,
        modelValue: row.popoverVisible,
        "onUpdate:modelValue": $event => row.popoverVisible = $event,
        placement: "bottom",
        trigger: "click",
        "popper-style": "min-width: 0px;width: auto;background:#f3f3f3",
        teleported: false,
        "show-arrow": false
      }, {
        reference: _withCtx(() => [_createElementVNode("div", _hoisted_62, [_hoisted_63, _createVNode(_component_el_link, {
          underline: false
        }, {
          default: _withCtx(() => [_createVNode(_component_svg_icon, {
            class: "tip",
            iconName: "unfold",
            iconSize: "15px"
          })]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_64, [_createVNode(_component_el_button, {
          class: "button-default",
          color: "black",
          style: {
            "margin": "5px 0"
          },
          onClick: $event => $setup.deliveredLogistics(row)
        }, {
          default: _withCtx(() => [_hoisted_65]),
          _: 2
        }, 1032, ["onClick"])])]),
        _: 2
      }, 1032, ["modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true), row.expressStateName == '已签收' ? (_openBlock(), _createElementBlock("div", _hoisted_66, "已签收")) : _createCommentVNode("", true)]))]),
      _: 1
    })]),
    _: 1
  }, 8, ["data", "loading", "onHeaderCellClick", "onScroll"])]), _createElementVNode("div", _hoisted_67, [_createVNode(_component_el_pagination, {
    "page-size": $setup.converPaginationData.pageSize,
    "onUpdate:pageSize": _cache[8] || (_cache[8] = $event => $setup.converPaginationData.pageSize = $event),
    "current-page": $setup.converPaginationData.currentPage,
    "onUpdate:currentPage": _cache[9] || (_cache[9] = $event => $setup.converPaginationData.currentPage = $event),
    "page-sizes": $setup.converPaginationData.pageSizes,
    background: true,
    layout: "total, sizes, prev, pager, next, jumper",
    total: $setup.converPaginationData.totalSize,
    onSizeChange: $setup.paginationSizeConverChange,
    onCurrentChange: $setup.paginationCurrentConverChange
  }, null, 8, ["page-size", "current-page", "page-sizes", "total", "onSizeChange", "onCurrentChange"])])]);
}